import React from 'react';
import styled from 'styled-components';
import {
  theme,
  Text,
  TableComponent,
  ButtonAnt,
} from '@pfmam/pfmam';
import { Link } from 'react-router-dom';
import { InfoCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Box, Container } from '../../../styles/globalStyle';
import NoDataFound from '../../../common/components/noDataFound';
import AccountActions from '../accountActions';
import { Tooltip } from 'antd';
import moment from 'moment';
const Wrapper = styled.div`
  padding-top: 40px;
`;

const StatusIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: ${({ $isYes }) => ($isYes ? '#1F9D55' : '#C4C4C4')};
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`;


const WireAccountsContainer = ({
  wireAccounts,
  handleAction,
  handleMenuClick,
  canEditWiresAccount = false,
  webuserAccessType,
  isGlobalSettingsPage,
}) => {
  const getColumns = () => {
    const permissionColumn = {
      title: 'Permissions',
      dataIndex: 'permissions',
      key: 'permissions',
      sorter: false,
      className: 'sort-space-none',
      width: 400,
      render: (text) => (
        <>
          {text && text.length > 0 ? (
            text.map((permission) => {
              return (
                <Text lineheight="20px" margin="0 0 4px 0" label={permission} />
              );
            })
          ) : (
            <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              lineheight="20px"
              margin="4px 0 0"
              label={'- - - -'}
            />
          )}
        </>
      ),
    };

    const columns = [
      {
        title: 'Bank / Nickname',
        dataIndex: 'bankName',
        key: 'bankName',
        align: 'left',
        sorter: (a, b) => a.bankName.localeCompare(b.bankName),
        className: 'sort-space-none',
        width: 400,
        render: (text, record) => (
          <>
            {text}{' '}
            <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              lineheight="20px"
              margin="4px 0 0"
              label={record.nickName ? record.nickName : '- - - -'}
            />
            {isGlobalSettingsPage && record.pending === 0 ? (
              <Box
                boxcolor="#F49B48"
                radius="2px"
                padding="2px 8px"
                textalign="center"
                margin="8px 0 0"
                display="inline-block"
              >
                <Text
                  label="Awaiting Admin Approval"
                  fontSize={`${theme.font_size.size_m}`}
                  color={`${theme.colors.black_secondary}`}
                  lineheight="16px"
                />
              </Box>
            ) : null}
          </>
        ),
      },
      {
        title: 'Last Modified (ET)',
        dataIndex: 'lastModifiedDate',
        key: 'lastModifiedDate',
        sorter: (a, b) =>{
          var aDate =a.lastModifiedDate;
          var bDate= b.lastModifiedDate;
          if(aDate===null)
          {
            aDate= moment("1900-01-01");
          }
          if(bDate===null)
          {
            bDate = moment("1900-01-01");
          }
          return moment(aDate).unix() - moment(bDate).unix();
          
        },
        className: 'sort-space-none',
        width: 300,
        render: (text) => (
          <Text
          label={
             // Avoiding using Moment library because it keeps screwing up the timezone. The CST to EST conversion is now made in the database
            text != null
              ? new Date(text).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : null
          }
          />
        ),
      },
      {
        title: 'Beneficiary Address Captured',
        dataIndex: 'beneficiaryAddress',
        key: 'beneficiaryAddress',
        width: 600,
        render: (text, record) => (
          <>
            {text}
              <StatusIndicator $isYes={record.hasBeneficiaryAddress}>
                  <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              label={record.hasBeneficiaryAddress ? '✓' : ''}
            />
              </StatusIndicator>
           
          </>
        ),
      },
      {
        title: 'Beneficiary Name/Details',
        dataIndex: 'beneficiaryName',
        key: 'beneficiaryName',
        sorter: (a, b) => a.beneficiaryName.localeCompare(b.beneficiaryName),
        className: 'sort-space-none',
        width: 320,
        render: (text, record) => (
          <>
            {text}
            <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              lineheight="20px"
              margin="4px 0 0"
              label={record.details ? record.details : '- - - -'}
            />
          </>
        ),
      },
      {
        title: '',
        dataIndex: 'righticon',
        key: 'righticon',
        align: 'right',
        className: 'action-cell',
        width: 80,
        render: (_, record) => (
          <AccountActions
            type="Wire"
            record={record}
            canEditWiresAccount={canEditWiresAccount}
            handleMenuClick={handleMenuClick}
            isGlobalSettingsPage={isGlobalSettingsPage}
          />
        ),
      },
    ];

    if (isGlobalSettingsPage) {
      columns.splice(2, 0, permissionColumn);
    }
    return columns;
  };

  return (
    <Container>
      <Wrapper>
        <TableComponent
          className="table-primary"
          title={
            <Box
              display="flex"
              justifycontent="space-between"
              alignitems="center"
              padding="24px 48px 24px 32px"
              border={`1px solid ${theme.colors.grey_fossil}`}
              borderwidth="0 0 1px 0"
            >
              <Box display="flex" flexdirection="column">
                <Box display="flex" justifycontent="space-between" alignitems="center">
                  <Text
                    label="Linked Wire Accounts"
                    fontSize={`${theme.font_size.size_3xl}`}
                    lineheight="32px"
                    color={`${theme.colors.black_tertiary}`}
                  />
            {webuserAccessType == 0 && canEditWiresAccount ? (
                <Link
                  to={{
                    pathname: '/aba-lookup/wire',
                  }}
                >
                  <ButtonAnt
                    type="link"
                    label="Link New Wire Account"
                    icon={<PlusCircleOutlined />}
                    onClick={(e) => {
                      handleMenuClick(e, null, 'Wire');
                    }}
                  />
                </Link>
              ) : null}
                  {!isGlobalSettingsPage ? <Tooltip title="To view Pending Wire Instructions, visit the Wire Instructions page under Organizational Settings. Associated instructions will appear once out of Pending status."
                    overlayClassName="tooltip">
                    <InfoCircleOutlined
                      style={{ padding: '2px 2px 2px 2px', cursor: 'pointer' }}
                    />
                  </Tooltip> : null}
                </Box>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '8px 0 0' }}>
                  <li style={{ listStyleType: 'disc' }}>
                    <p style={{ margin: '8px 0 0', fontSize: '14px', lineHeight: '20px', color: theme.colors.black_tertiary,fontStyle: 'normal' }}>
                      <span style={{ fontWeight: 700}}>Add Beneficiary Physical Address:</span>{' '}
                      For any instruction showing a grey circle in the Beneficiary Address Captured column, add the beneficiary&apos;s (recipient of the funds) physical address by selecting the three dots &gt; Add Beneficiary Address. The circle will turn green once the address is saved.
                    </p>
                  </li>
                  <li style={{ listStyleType: 'disc' }}>
                        <p
                                                style={{
                                                  fontSize: '14px',
                                                  fontStyle: 'normal',
                                                  color: theme.colors.black_tertiary,
                                                  lineHeight: '20px',
                                                  margin: '8px 0 0',
                                                }}
                                              >Effective Fall 2026, all wire instructions must include the beneficiary's physical address. This requirement is driven by global wire processing standards (ISO 20022) and applies across the industry, not specifically to the Fund. Ensure all required address fields are completed to avoid processing delays.</p>
             
                  </li>
                </ul>
              </Box>
              {/* {isGlobalSettingsPage ? (
                <ButtonAnt
                  type="link"
                  label="Add Wire Account"
                  icon={<PlusCircleOutlined />}
                  onClick={(e) => {
                    handleMenuClick(e, null, 'Wire');
                  }}
                />
              ) : (
                <Link
                  to={{
                    pathname: '/settings',
                    accType: 'Wire',
                  }}
                >
                  <ButtonAnt type="link" label="Manage Wire Accounts" />
                </Link>
              )} */}
            </Box>
          }
          columns={getColumns()}
          dataSource={wireAccounts}
          locale={{
            emptyText: <NoDataFound text="No Wire accounts" />,
          }}
          showSorterTooltip={false}
          pagination={
            wireAccounts.length > 10
              ? {
                position: ['bottomRight'],
                showQuickJumper: true,
                size: 'default',
              }
              : false
          }
          onRow={(record) => ({
            onClick: () => {
              handleAction('Wire', 'details', record);
            },
          })}
        />
      </Wrapper>
    </Container>
  );
};

export default WireAccountsContainer;
